export enum AuthMutationTypes {
  'SET_GENERATE_TOKEN' = 'SET_GENERATE_TOKEN',
  'SET_AUTH_USER' = 'SET_AUTH_USER',
  'SET_USER_VERIFICATION' = 'SET_USER_VERIFICATION',
  'SET_USER_INFO' = 'SET_USER_INFO',
  'SET_FIRST_LOGIN' = 'SET_FIRST_LOGIN'
}
